<script lang="ts" setup>
import { VButton, VDrawer, VIcon } from "@app/core";
import { storeToRefs } from "pinia";

import { usePartnershipStore } from "@/features/partnership";
import { useGlobalFiltersStore } from "@/shared/stores/useGlobalFiltersStore";
import { useVendorFiltersStore } from "@/shared/stores/useVendorFiltersStore";
import BrandsFilter from "@/widgets/filters/components/BrandsFilter.vue";
import ChannelsFilter from "@/widgets/filters/components/ChannelsFilter.vue";
import GlobalFilterSidebarHeader from "@/widgets/filters/components/GlobalFilterSidebarHeader.vue";
import ProductFilter from "@/widgets/filters/components/ProductFilter.vue";
import SavedFilters from "@/widgets/filters/components/SavedFilters.vue";
import VendorBrandsFilter from "@/widgets/filters/components/VendorBrandsFilter.vue";
import VendorProductFilter from "@/widgets/filters/components/VendorProductFilter.vue";

const filtersStore = useGlobalFiltersStore();
const vendorFiltersStore = useVendorFiltersStore();
const { isFilterVisible } = filtersStore;

const { isVendorMode } = storeToRefs(usePartnershipStore());

const handleReset = () => {
  // resetAllFilters clears the whole URL query (vendor_* params included),
  // vendor selection state is reset separately
  filtersStore.resetAllFilters();
  vendorFiltersStore.resetSelection();
};
</script>

<template>
  <VDrawer
    id="global-filter"
    keep-alive
  >
    <template #header>
      <GlobalFilterSidebarHeader />
    </template>

    <!-- Content -->
    <div class="flex flex-col gap-4 w-full">
      <BrandsFilter v-if="isFilterVisible('brands') && !isVendorMode" />
      <VendorBrandsFilter v-else-if="isFilterVisible('brands')" />
      <ChannelsFilter v-if="isFilterVisible('channels')" />
      <ProductFilter v-if="isFilterVisible('products') && !isVendorMode" />
      <VendorProductFilter v-else-if="isFilterVisible('products')" />

      <!-- Last Refresh Date -->
      <div
        v-if="filtersStore.refreshDate"
        class="flex items-center gap-2 px-3 py-2.5 rounded-lg
               bg-surface-light border border-border-light"
      >
        <div
          class="flex items-center justify-center w-8 h-8 rounded-md
                 bg-primary-300 text-white"
        >
          <VIcon
            icon="lucide:info"
            size="16"
          />
        </div>
        <div class="flex flex-col flex-1">
          <span class="text-xs font-medium text-secondaryText">Latest Data Refresh</span>
          <span class="text-sm font-semibold text-mainText">{{ filtersStore.refreshDate }}</span>
        </div>
      </div>

      <VButton
        class="w-full"
        icon="lucide:rotate-ccw"
        text="Reset to Default"
        variant="negative"
        @click="handleReset"
      />

      <!-- Saved Filters Section -->
      <SavedFilters />
    </div>
  </VDrawer>
</template>
